
export const pageStatusEnum = {
	loading: "loading",
	complete: "complete",
	errored: "errored",
}

